import React from "react";
import cn from "classnames";
import s from "./Tabs.module.scss";

interface TabProps {
  index: number;
  title: string;
  isActive: boolean;
  onClick: () => void;
}

const Tab: React.FC<TabProps> = ({ title, isActive, onClick }) => (
  <button
    tabIndex={0}
    className={cn(s.tabButton, {
      [s.isActive]: isActive,
    })}
    onClick={onClick}
    role="tab"
    aria-selected={isActive}
    type="button"
  >
    {title}
  </button>
);

export default React.memo(Tab);
